export { default as VictoryPie } from "./victory-pie";
export { default as Slice } from "./slice";


//////////////////
// WEBPACK FOOTER
// ./node_modules/victory-pie/es/index.js
// module id = 2691
// module chunks = 0